import { render } from "./CampaignPlayer.vue?vue&type=template&id=a150ec1c&scoped=true"
import script from "./CampaignPlayer.vue?vue&type=script&lang=js"
export * from "./CampaignPlayer.vue?vue&type=script&lang=js"

import "./CampaignPlayer.vue?vue&type=style&index=0&id=a150ec1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a150ec1c"]])

export default __exports__